import { CustomerDBStatus, CustomersBySerial } from '@ip6m/types';
import { Injectable } from '@nestjs/common';
import { DatabaseService } from '../database/services/database/database.service';


@Injectable()
export class MicroServiceService {

  constructor(private database: DatabaseService) {}

  get getDBStatus(): CustomerDBStatus {
    return this.database.dbStatus;
  }

  getData(sn: string) {
    
    return this.database.getData(sn);
  }

}
